<article class="call2action-event-card card bg-primary text-light">
  <main class="call2action-event-card__main">
    <h2 class="fw-bold font-secondary call2action-event-card__subtitle h5 text-max-width mb-3 mb-sm-4">
      {{ subtitle || ('evenement-aanmelden-subtitel' | fromDictionary) }}
    </h2>
    <a [routerLink]="['/', 'activiteiten', 'aanmelden']" class="button button--tertiary">
      {{ 'evenement-aanmelden-knop-tekst' | fromDictionary }}
    </a>
  </main>
</article>
